// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3o2Zo","messages":"Chat_messages__1QAYi","dateDivider":"Chat_dateDivider__2NZfA"};